export default __webpack_public_path__ + "static/media/GirlWithHat_tmb.bf3c1997.jpg";